
import qs from 'qs';

import { Observable, Subject, from  } from 'rxjs'; 
import { map,mapTo,catchError,debounceTime,distinctUntilChanged } from 'rxjs/operators';

import { ORGANIZATION_WEB_API_SERVER } from '../server'

import { AuthInfo } from '@/util/user/authInfo';

import { athubAxios    } from '@/util'
import { HeaderBuilder } from '@/util/athub-axios/header'


export class DC {
    
    static sysDCInfoUrl = [ ORGANIZATION_WEB_API_SERVER , "AthubCloud/sys/room/getSysRoomList.sp" ].join("/");

    static getAll(){
        
        let formData = {};
        
        formData.appId = 'WEB';
        formData.token = AuthInfo.token;
        
        let athubconfig = {
            headers:{
                "Content-Type": "application/x-www-form-urlencoded",
	            "Accept":"application/json",   
            }   
        }
        
        return from( athubAxios.postByForm( DC.sysDCInfoUrl, formData ) );
    }
}